module.exports = __webpack_public_path__ + "static/media/sidebar_kittel.ac108e08.jpg";